import {
    UPLOAD_FREELANCERS,
    UPLOAD_FREELANCERS_SUCCESS,
    UPLOAD_FREELANCERS_FAILURE,
    CREATE_FREELANCERS,
    CREATE_FREELANCERS_RESET,
    CREATE_FREELANCERS_SUCCESS,
    CREATE_FREELANCERS_FAILURE,
} from '../actions';

const initialState = {
    meta: undefined,
    error: undefined,
    payload: undefined,
    uploading: undefined,
    uploaded: undefined,
    importing: false,
    imported: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_FREELANCERS:
            return {
                ...state,
                meta: action.payload.meta,
                uploading: true,
                payload: action.payload,
            };
        case UPLOAD_FREELANCERS_SUCCESS:
            return {
                ...state,
                meta: action.payload.meta,
                uploading: false,
                uploaded: true,
                payload: action.payload.content,
                error: undefined,
            };
        case UPLOAD_FREELANCERS_FAILURE:
            return {
                ...state,
                meta: action.payload.meta,
                uploading: false,
                uploaded: false,
                payload: action.payload,
                error: action.payload.meta.detail,
            };
        case CREATE_FREELANCERS:
            return {
                ...state,
                importing: true,
                imported: false,
                payload: action.payload,
            };
        case CREATE_FREELANCERS_RESET:
            return {
                ...state,
                importing: false,
                imported: false,
                error: null,
                payload: null,
            };
        case CREATE_FREELANCERS_SUCCESS:
            return {
                ...state,
                meta: action.payload.meta,
                importing: false,
                imported: true,
                payload: action.payload.content,
                error: undefined,
            };
        case CREATE_FREELANCERS_FAILURE:
            return {
                ...state,
                meta: action.payload.meta,
                importing: false,
                imported: false,
                payload: action.payload,
                error: action.payload.meta.detail,
            };
        default:
            return state;
    }
};

export default reducer;
